import { useState } from "react";
import { makePostApiCall, makeGetApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function CreditReturnsViewModel(logout, addSnackbar) {
  const [creditReturns, setCreditReturns] = useState({ data: [] });
  const [loading, setLoading] = useState(true);
  const [emptyModal, setEmptyModelOpen] = useState({ open: false, childComponent: null });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: <ModelErrorComponent setOpen={setEmptyModelOpen} subtitle={subtitle} title={title} />,
      open: true,
    });
  };

  const getCreditReturns = async function (search = null, page = 1) {
    setLoading(true);
    const callResult = await makePostApiCall("creditReturns/search", {
      page,
      filters: { search },
    });
    if (callResult.success) {
      setCreditReturns(callResult.data);
    } else {
      if (callResult.errorStatus === 401) logout();
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  return { creditReturns, loading, getCreditReturns, emptyModal, setEmptyModelOpen };
}

export function CreditReturnDetailsViewModel(creditReturnId, logout, addSnackbar) {
  const [creditReturn, setCreditReturn] = useState(null);
  const [loading, setLoading] = useState(true);
  const [emptyModal, setEmptyModelOpen] = useState({ open: false, childComponent: null });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: <ModelErrorComponent setOpen={setEmptyModelOpen} subtitle={subtitle} title={title} />,
      open: true,
    });
  };

  const loadCreditReturn = async function () {
    const callResult = await makeGetApiCall(`creditReturns/${creditReturnId}`);
    if (callResult.success) {
      setCreditReturn(callResult.data);
    } else {
      if (callResult.errorStatus === 401) logout();
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const createCreditReturn = async function (payload) {
    const callResult = await makePostApiCall("creditReturns", payload);
    if (callResult.success) {
      addSnackbar(new SnackbarData(generateUniqueNumber(), "Return created.", SnackbarType.Success));
      const id = callResult.data?.credit_return?.id;
      if (id) window.location = `/credit-returns/${id}`;
    } else {
      if (callResult.errorStatus === 401) logout();
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const scanReturnItem = async function (barcode, options = {}) {
    const callResult = await makePostApiCall(`creditReturns/${creditReturnId}/items/scan`, {
      barcode,
      ...options,
    });
    if (callResult.success) {
      addSnackbar(new SnackbarData(generateUniqueNumber(), "Returned item added.", SnackbarType.Success));
      await loadCreditReturn();
    } else {
      if (callResult.errorStatus === 401) logout();
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const postCreditReturn = async function () {
    const callResult = await makePostApiCall(`creditReturns/${creditReturnId}/post`);
    if (callResult.success) {
      addSnackbar(new SnackbarData(generateUniqueNumber(), callResult.data.message, SnackbarType.Success));
      await loadCreditReturn();
    } else {
      if (callResult.errorStatus === 401) logout();
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  return {
    creditReturn,
    loading,
    emptyModal,
    setEmptyModelOpen,
    showErrorModal,
    loadCreditReturn,
    createCreditReturn,
    scanReturnItem,
    postCreditReturn,
  };
}
